/* eslint-disable import/prefer-default-export */
// 默认选中的菜单模块，与default.config.ts保持一致，copy出一份拿到外层配置中
export const defaultMenuIds: string[] = [
  '1',
  '1000',
  '1001001',
  '100100101',
  '100100102',
  '100100103',
  '100100104',
  '100100105',
  '100100106',
  '10010010601',
  '10010010602',
  '10010010603',
  '10010010604',
  '10010010605',
  '10010010606',
  '10010010607',
  '10010010608',
  '100100107',
  '10010010701',
  '10010010702',
  '10010010703',
  '10010010704',
  '10010010705',
  '10010010706',
  '10010010707',
  '10010010708',
  '100100108',
  '10010010801',
  '10010010802',
  '10010010803',
  '10010010804',
  '1001002',
  '100100201',
  '100100202',
  '100100203',
  '100100204',
  '100100205',
  '100100206',
  '100100207',
  '100100208',
  '100100209',
  '100100210',
  '100100211',
  '1001003',
  '1001004',
  '1003002',
  '1003001',
  '1003003',
  '1005001',
  '1001',
  '1003',
  '1005',
  // 移动端权限
  '2',
  '2001',
  '200102',
  '2002',
  '200201',
  '2003',
  `200301`,
  '2004',
  '200402',
];
